import React from 'react'
import ErrorModal from '../../../ErrorModal'
import { FormlessJourneyProps } from '../FormlessJourney'
import { FormlessJourneyWithContinueCta } from './FormlessJourneyWithContinueCta'
import withDetectRefresh from '../../../HOC/withDetectRefresh'

const FormlessJourneyWithContinueCtaWrapper = ({
  attribution,
  experimentName,
  lenderDetails,
  shouldShowConfetti,
  // injected props from HOC
  apiError,
  redirectUrl,
  closeError
}: FormlessJourneyProps): JSX.Element => {
  return (
    <>
      {apiError && (
        <ErrorModal
          titleText="Sorry"
          ctaText="Please try again"
          onClick={closeError}
        >
          There was a problem submitting your application
        </ErrorModal>
      )}

      {!apiError && attribution && (
        <FormlessJourneyWithContinueCta redirectUrl={redirectUrl} source={attribution.source} experimentName={experimentName} lenderDetails={lenderDetails} shouldShowConfetti={shouldShowConfetti} />
      )}
    </>
  )
}

export default withDetectRefresh(FormlessJourneyWithContinueCtaWrapper)
